/**
 * Host Guests Management API Service
 * Handles all host guest management operations
 */

import { apiClient } from './apiClient';
import {
  HostGuestListResponse,
  HostGuestDetailResponse,
  HostGuestListParams,
} from '../types/hostGuest';

class HostGuestsService {
  private baseUrl = '/host/guests';

  /**
   * Get list of all guests for the current host
   */
  async getGuests(params: HostGuestListParams = {}): Promise<HostGuestListResponse> {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page.toString());
    if (params.page_size) queryParams.append('page_size', params.page_size.toString());
    if (params.search) queryParams.append('search', params.search);
    if (params.event_id) queryParams.append('event_id', params.event_id.toString());
    if (params.status && params.status.length > 0) {
      params.status.forEach(s => queryParams.append('status', s));
    }

    const queryString = queryParams.toString();
    const url = queryString ? `${this.baseUrl}/?${queryString}` : `${this.baseUrl}/`;

    const response = await apiClient.get<HostGuestListResponse>(url);
    return response.data;
  }

  /**
   * Get single guest details with companions
   */
  async getGuest(guestId: number): Promise<HostGuestDetailResponse> {
    const response = await apiClient.get<HostGuestDetailResponse>(`${this.baseUrl}/${guestId}/`);
    return response.data;
  }
}

export const hostGuestsService = new HostGuestsService();
export default hostGuestsService;
